// @flow
import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';

import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog';
import { CheckoutButton } from 'app/common/layouts/commonShop';
import { LoadingModal } from 'app/common/components/Loader';

import useRepeatOrder from './useRepeatOrder';
import { type OrderItem } from '../../OrderData';


type Props = {
  className?: string,
  orderItems: Array<OrderItem>,
  onRedirectToCart?: () => void,
}

const OrderRepeatButton = ({
  className,
  orderItems,
  onRedirectToCart,
}: Props) => {
  const dispatch = useDispatch();

  const [repeating, handleRepeatOrder] = useRepeatOrder({
    dispatch,
    orderItems,
    onRedirectToCart,
  });

  return (
    <Fragment>
      <ConfirmationDialog
        onConfirm={handleRepeatOrder}
        text="Текущая корзина будет очищена и заполнена теми товарами из заказа, которые есть в магазине в настоящий момент."
        confirmButtonText="Хорошо"
      >
        {handleConfirm => (<CheckoutButton
          className={className}
          onClick={handleConfirm}
          outline
        >
          {'Повторить заказ'}
        </CheckoutButton>)}
      </ConfirmationDialog>
      {repeating && <LoadingModal />}
    </Fragment>
  );
};

export default OrderRepeatButton;
